export const earnpoint = {
    title: 'รับคะแนน',
    whopper_level: 'Whopper {0} Level',
    have_crowns: 'คุณมี {0} คราวพอยท์',
    show_our_staff: 'แสดงคิวอาร์โค้ดนี้กับพนักงานเพื่อรับคะแนน',
    qr_code_valid: 'QR code หมดอายุใน',
    min: ' นาที',
    your_point_update: 'คะแนนของคุณจะได้รับการอัปเดตในวันถัดไป 14.00 น.',
    point_history: 'ประวัติคะแนน',
    benefits: 'Benefits'
};
